(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
        this.header.style.setProperty('top', '0px', 'important');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    /* Pins both the theme header and the floating mc2 nav to the very top. */
    pinToTop() {
      document.documentElement.style.setProperty('--mc2-announcement-offset', '0px', 'important');

      if (this.header) {
        this.header.style.setProperty('top', '0px', 'important');
      }

      document.querySelectorAll('.mc2-nav').forEach((nav) => {
        nav.style.setProperty('top', '0px', 'important');
      });
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      this.pinToTop();

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.pinToTop();
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.pinToTop();
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.pinToTop();
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc2-testimonials-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mc2-testimonial-slider')) {
    class Mc2TestimonialSlider extends HTMLElement {
      constructor() {
        super();
        this.onResize = this.onResize.bind(this);
        this.onPointerDown = this.onPointerDown.bind(this);
        this.onPointerMove = this.onPointerMove.bind(this);
        this.onPointerUp = this.onPointerUp.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
      }

      connectedCallback() {
        this.viewport = this.querySelector('[data-slider-viewport]');
        this.track = this.querySelector('[data-slider-track]');
        if (!this.viewport || !this.track) return;

        this.originalSlides = Array.from(this.track.children);
        this.slideCount = this.originalSlides.length;
        this.prevBtn = this.querySelector('[data-slider-prev]');
        this.nextBtn = this.querySelector('[data-slider-next]');
        this.dotsWrap = this.querySelector('[data-slider-dots]');

        this.loop = this.dataset.loop === 'true';
        this.autoplay = this.dataset.autoplay === 'true';
        this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10) || 5000;
        this.pauseOnHover = this.dataset.pauseHover === 'true';
        this.transitionSpeed = parseInt(this.dataset.transitionSpeed, 10) || 500;
        this.dragEnabled = this.dataset.drag !== 'false';

        this.currentIndex = 0;
        this.isAnimating = false;
        this.isDragging = false;
        this.dragStartX = 0;
        this.dragCurrentX = 0;

        if (this.slideCount <= 1) {
          if (this.prevBtn) this.prevBtn.style.display = 'none';
          if (this.nextBtn) this.nextBtn.style.display = 'none';
          if (this.dotsWrap) this.dotsWrap.style.display = 'none';
          return;
        }

        if (this.loop) this.setupLoopClones();
        this.bindEvents();

        window.requestAnimationFrame(() => {
          this.buildDots();
          this.goToSlide(this.currentIndex, false);
          if (this.autoplay) this.startAutoplay();
        });
      }

      disconnectedCallback() {
        this.stopAutoplay();
        window.removeEventListener('resize', this.onResize);
        if (this.viewport) {
          this.viewport.removeEventListener('pointerdown', this.onPointerDown);
          this.viewport.removeEventListener('keydown', this.onKeydown);
        }
        clearTimeout(this._resizeTimer);
      }

      setupLoopClones() {
        const beforeFrag = document.createDocumentFragment();
        const afterFrag = document.createDocumentFragment();

        this.originalSlides.forEach((slide) => {
          const cloneBefore = slide.cloneNode(true);
          cloneBefore.setAttribute('aria-hidden', 'true');
          cloneBefore.setAttribute('data-clone', 'true');
          beforeFrag.appendChild(cloneBefore);

          const cloneAfter = slide.cloneNode(true);
          cloneAfter.setAttribute('aria-hidden', 'true');
          cloneAfter.setAttribute('data-clone', 'true');
          afterFrag.appendChild(cloneAfter);
        });

        this.track.insertBefore(beforeFrag, this.track.firstChild);
        this.track.appendChild(afterFrag);

        this.currentIndex = this.slideCount;
      }

      bindEvents() {
        if (this.prevBtn) {
          this.prevBtn.addEventListener('click', () => {
            this.stopAutoplay();
            this.prev();
            if (this.autoplay) this.startAutoplay();
          });
        }
        if (this.nextBtn) {
          this.nextBtn.addEventListener('click', () => {
            this.stopAutoplay();
            this.next();
            if (this.autoplay) this.startAutoplay();
          });
        }

        window.addEventListener('resize', this.onResize);
        this.viewport.addEventListener('keydown', this.onKeydown);

        if (this.dragEnabled) {
          this.viewport.addEventListener('pointerdown', this.onPointerDown);
        }

        if (this.autoplay && this.pauseOnHover) {
          this.addEventListener('mouseenter', () => this.stopAutoplay());
          this.addEventListener('mouseleave', () => this.startAutoplay());
        }
      }

      getStep() {
        const slide = this.track.children[0];
        if (!slide) return 0;
        const style = getComputedStyle(this.track);
        const gap = parseFloat(style.columnGap || style.gap) || 0;
        return slide.getBoundingClientRect().width + gap;
      }

      getVisibleCount() {
        const step = this.getStep();
        if (!step) return 1;
        return Math.max(1, Math.round(this.viewport.getBoundingClientRect().width / step));
      }

      goToSlide(index, animate) {
        const step = this.getStep();
        const offset = -index * step;
        this.track.style.transition = animate ? `transform ${this.transitionSpeed}ms ease` : 'none';
        this.track.style.transform = `translateX(${offset}px)`;
        this.currentIndex = index;
        this.updateDots();
        this.updateArrowState();
      }

      moveTo(newIndex, animate) {
        if (this.isAnimating) return;
        animate = animate !== false;

        if (!this.loop) {
          const max = Math.max(0, this.slideCount - this.getVisibleCount());
          newIndex = Math.min(Math.max(newIndex, 0), max);
          if (newIndex === this.currentIndex) return;
        }

        this.isAnimating = true;
        this.goToSlide(newIndex, animate);

        const delay = animate ? this.transitionSpeed : 0;
        window.setTimeout(() => {
          if (this.loop) {
            if (newIndex >= this.slideCount * 2) {
              this.goToSlide(newIndex - this.slideCount, false);
            } else if (newIndex < this.slideCount) {
              this.goToSlide(newIndex + this.slideCount, false);
            }
          }
          this.isAnimating = false;
        }, delay);
      }

      next() {
        this.moveTo(this.currentIndex + 1);
      }

      prev() {
        this.moveTo(this.currentIndex - 1);
      }

      startAutoplay() {
        this.stopAutoplay();
        this._autoplayTimer = window.setInterval(() => this.next(), this.autoplaySpeed);
      }

      stopAutoplay() {
        if (this._autoplayTimer) window.clearInterval(this._autoplayTimer);
      }

      buildDots() {
        if (!this.dotsWrap) return;
        this.dotsWrap.innerHTML = '';

        const count = this.loop
          ? this.slideCount
          : Math.max(1, this.slideCount - this.getVisibleCount() + 1);

        for (let i = 0; i < count; i++) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'mc2-testimonials-slider__dot';
          dot.setAttribute('role', 'tab');
          dot.setAttribute('aria-label', 'Go to testimonial ' + (i + 1));
          dot.addEventListener('click', () => {
            this.stopAutoplay();
            this.moveTo(this.loop ? this.slideCount + i : i);
            if (this.autoplay) this.startAutoplay();
          });
          this.dotsWrap.appendChild(dot);
        }
        this.updateDots();
      }

      updateDots() {
        if (!this.dotsWrap) return;
        const dots = Array.from(this.dotsWrap.children);
        let active = this.currentIndex;
        if (this.loop) {
          active = ((this.currentIndex - this.slideCount) % this.slideCount + this.slideCount) % this.slideCount;
        }
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === active));
      }

      updateArrowState() {
        if (this.loop || !this.prevBtn || !this.nextBtn) return;
        const max = Math.max(0, this.slideCount - this.getVisibleCount());
        this.prevBtn.disabled = this.currentIndex <= 0;
        this.nextBtn.disabled = this.currentIndex >= max;
      }

      onResize() {
        clearTimeout(this._resizeTimer);
        this._resizeTimer = window.setTimeout(() => {
          if (!this.loop) {
            this.buildDots();
            const max = Math.max(0, this.slideCount - this.getVisibleCount());
            if (this.currentIndex > max) this.currentIndex = max;
          }
          this.goToSlide(this.currentIndex, false);
        }, 150);
      }

      onKeydown(e) {
        if (e.key === 'ArrowLeft') {
          this.stopAutoplay();
          this.prev();
          if (this.autoplay) this.startAutoplay();
        } else if (e.key === 'ArrowRight') {
          this.stopAutoplay();
          this.next();
          if (this.autoplay) this.startAutoplay();
        }
      }

      onPointerDown(e) {
        if (this.isAnimating) return;
        this.isDragging = true;
        this.dragStartX = e.clientX;
        this.dragCurrentX = e.clientX;
        this.dragStep = this.getStep();
        this.baseTransform = -this.currentIndex * this.dragStep;
        this.track.style.transition = 'none';

        this.viewport.setPointerCapture(e.pointerId);
        this.viewport.addEventListener('pointermove', this.onPointerMove);
        this.viewport.addEventListener('pointerup', this.onPointerUp);
        this.viewport.addEventListener('pointercancel', this.onPointerUp);
        this.stopAutoplay();
      }

      onPointerMove(e) {
        if (!this.isDragging) return;
        this.dragCurrentX = e.clientX;
        const delta = this.dragCurrentX - this.dragStartX;
        this.track.style.transform = `translateX(${this.baseTransform + delta}px)`;
      }

      onPointerUp() {
        if (!this.isDragging) return;
        this.isDragging = false;

        const delta = this.dragCurrentX - this.dragStartX;
        const threshold = this.dragStep * 0.2;

        this.viewport.removeEventListener('pointermove', this.onPointerMove);
        this.viewport.removeEventListener('pointerup', this.onPointerUp);
        this.viewport.removeEventListener('pointercancel', this.onPointerUp);

        if (delta < -threshold) {
          this.next();
        } else if (delta > threshold) {
          this.prev();
        } else {
          this.goToSlide(this.currentIndex, true);
        }

        if (this.autoplay) this.startAutoplay();
      }
    }

    customElements.define('mc2-testimonial-slider', Mc2TestimonialSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
